<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    width="26%"
    @close="confirmCustomDialog('cancel')"
  >
    <div v-if="customType === 'confirmDelPerson'">
      <p class="content">{{ content }}</p>
      <p class="description" v-if="isShowDes">{{ description }}</p>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmCustomDialog('confim2')">{{ confirmText2 }}</el-button>
        <el-button size="small" type="primary" @click="confirmCustomDialog('confim')">{{ confirmText }}</el-button>
        <el-button size="small" v-if="isShowClose" @click="confirmCustomDialog('cancel')">{{ cancelText }}</el-button>
      </div>
    </div>
    <div v-if="customType === 'confirmDelGroup'">
      <p class="content">{{ content }}</p>
      <p class="description" v-if="isShowDes">{{ description }}</p>
      <p style="color:#999999; font-size: 12px; margin-bottom: 20px"><input type="checkbox" @change="changeGroupDelType($event)" />{{$t("wm_lang_html_ed8f43")}}</p>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmCustomDialog('confim')">{{ confirmText3 }}</el-button>
        <el-button size="small" v-if="isShowClose" @click="confirmCustomDialog('cancel')">{{ cancelText }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import dialogHandle from "../../utils/dialogHandle";
  export default {
    name: 'customConfirm',
    mixins: [dialogHandle],
    data() {
      return {}
    },
    props: {
      // visible: { // 控制弹窗显示
      //   type: Boolean,
      //   default: false
      // },
      customType: { // 弹窗类型
        type: String,
        default: ''
      },
      title: { // 弹窗标题
        type: String,
        // default: this.$i18n.t('wm_lang_c45357')
        default () {
          return this.$i18n.t('wm_lang_c45357')
        }
      },
      content: { // 删除弹窗内容
        type: String,
        default: ''
      },
      description: { // 删除弹窗描述
        type: String,
        default: ''
      },
      isShowDes: { // 是否显示描述
        type: Boolean,
        default: false
      },
      isShowClose: { // 是否显示取消按钮
        type: Boolean,
        default: false
      },
      confirmText3: { // 按钮显示文字
        type: String,
        default () {
          return this.$i18n.t('wm_lang_38cf16')
        }
      },
      confirmText2: { // 按钮显示文字
        type: String,
        default () {
          return this.$i18n.t('wm_lang_042be4')
        }
      },
      confirmText: { // 按钮显示文字
        type: String,
        default () {
          return this.$i18n.t('wm_lang_732796')
        }
      },
      cancelText: { // 取消显示文字
        type: String,
        default () {
          return this.$i18n.t('wm_lang_625fb2')
        }
      },
    },
    methods: {
      init() {
        // 初始化
      },
      /**
       * 点击按钮的回调
       * params {String} confim 确定 cancel 取消
       */
      confirmCustomDialog(val){
        this.$emit('confirmCustomDialog', val);
      },
      /**
       * 复选框选中的回调
       * params {String} confim 确定 cancel 取消
       */
      changeGroupDelType(val){
        this.$emit('changeGroupDelType', val);
      },
    },
  }
</script>

<style scoped>
  .content {
    letter-spacing: 1px;
  }
  .description {
    color: #aaa;
    margin-top: 10px;
    letter-spacing: 1px;
  }
  .dialog-footer{ text-align: right}
</style>



// WEBPACK FOOTER //
// src/components/sub/customConfirm.vue